import Dashboard from 'types/entities/Dashboard';
import { GridSortModel } from '@mui/x-data-grid-pro';
import { DashboardTabState } from 'types/enums/DashboardTabState';
import { SearchParams } from '../../api/ResourceAPI';

export const DashboardActions = {
  DASHBOARD_ORDERS: 'DASHBOARD_ORDERS',
  CHANGE_DASHBOARD_PARENT_TAB: 'CHANGE_DASHBOARD_PARENT_TAB',
  // CHANGE_DASHBOARD_PAGE_MANAGEMENT: 'CHANGE_DASHBOARD_PAGE_MANAGEMENT',
  SET_DASHBOARD_ACTIVE_ORDERID: 'SET_DASHBOARD_ACTIVE_ORDERID',
  CHANGE_DASHBOARD_SEARCH_PARAMS_MANAGEMENT: 'CHANGE_DASHBOARD_SEARCH_PARAMS_MANAGEMENT',
  SET_DASHBOARD_ACTIVE_LAST_ORDERID: 'SET_DASHBOARD_ACTIVE_LAST_ORDERID',
  SET_DASHBOARD_ACTIVE_SCROLL_ORDERID: 'SET_DASHBOARD_ACTIVE_SCROLL_ORDERID',
  GET_DASHBOARD_ORDER_FILTER: 'GET_DASHBOARD_ORDER_FILTER',
  CHANGE_PAGE_SIZE: 'CHANGE_PAGE_SIZE',
  CHANGE_PAGE: 'CHANGE_PAGE',
  SORT_ORDER_DASHBOARD: 'SORT_ORDER_DASHBOARD',
  KPIMETRICGRID_DATA: 'KPIMETRICGRID_DATA',
  SORT_KPIMETRIC_GRID: 'SORT_KPIMETRIC_GRID',
  TODO_CREATE_ORDER_SCREEN: 'TODO_CREATE_ORDER_SCREEN',
} as const;

export const changeDashboardParentTabAction = (tab: DashboardTabState) => ({
  payload: { tab },
  type: DashboardActions.CHANGE_DASHBOARD_PARENT_TAB,
});

// export const changeDashboardPageAction = (newPage: number) => ({
//   payload: { newPage },
//   type: DashboardActions.CHANGE_DASHBOARD_PAGE_MANAGEMENT,
// });

export const injectDashboardOrdersAction = ({
  dashboard_orders,
  totalItems,
  totalPages,
  currentPage,
}: {
  dashboard_orders: Dashboard[] | null;
  totalItems: number;
  totalPages: number;
  currentPage?: number;
}) => ({
  payload: { dashboard_orders, totalItems, totalPages, currentPage },
  type: DashboardActions.DASHBOARD_ORDERS,
});

export const setActiveDashboardOrderIdAction = (orderId: Dashboard['id'] | null) => ({
  payload: { orderId },
  type: DashboardActions.SET_DASHBOARD_ACTIVE_ORDERID,
});

export const changeSearchDashboardParamsAction = (payload: SearchParams | null) => ({
  type: DashboardActions.CHANGE_DASHBOARD_SEARCH_PARAMS_MANAGEMENT,
  payload,
});

export const setActiveDashboardLastOrderIdAction = (orderId: Dashboard['id'] | null) => ({
  payload: { orderId },
  type: DashboardActions.SET_DASHBOARD_ACTIVE_LAST_ORDERID,
});

export const setActiveDashboardScrollOrderIdAction = (offsetTop: number) => ({
  payload: { offsetTop },
  type: DashboardActions.SET_DASHBOARD_ACTIVE_SCROLL_ORDERID,
});

export const setDashboardOrderFilterAction = (payload: any | null) => ({
  payload,
  type: DashboardActions.GET_DASHBOARD_ORDER_FILTER,
});

export const changePageSizeAction = (payload: number) => ({
  type: DashboardActions.CHANGE_PAGE_SIZE,
  payload,
});

export const changePageAction = (payload: number) => ({
  type: DashboardActions.CHANGE_PAGE,
  payload,
});

export const sortDashboardTodoAction = (payload: GridSortModel) => ({
  type: DashboardActions.SORT_ORDER_DASHBOARD,
  payload,
});

// KPI Metric Grid Data Action

export const setKpiMetricGridDataAction = ({
  kpiMetricGridData,
  totalItems,
  totalPages,
  currentPage,
}: {
  kpiMetricGridData: any[] | null;
  totalItems: number;
  totalPages: number;
  currentPage?: number;
}) => ({
  payload: { kpiMetricGridData, totalItems, totalPages, currentPage },
  type: DashboardActions.KPIMETRICGRID_DATA,
});

export const sortKpimetricGridAction = (payload: GridSortModel) => ({
  type: DashboardActions.SORT_KPIMETRIC_GRID,
  payload,
});

export const todoCreateOrderScreen = (payload: any) => ({
  type: DashboardActions.TODO_CREATE_ORDER_SCREEN,
  payload,
});

export const dashboardActions = {
  changeDashboardParentTabAction,
  // changeDashboardPageAction,
  injectDashboardOrdersAction,
  setActiveDashboardOrderIdAction,
  changeSearchDashboardParamsAction,
  setActiveDashboardLastOrderIdAction,
  setActiveDashboardScrollOrderIdAction,
  setDashboardOrderFilterAction,
  changePageSizeAction,
  changePageAction,
  sortDashboardTodoAction,
  setKpiMetricGridDataAction,
  sortKpimetricGridAction,
  todoCreateOrderScreen,
};
